// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import {
    getProductLineIsActive,
    getProductLineTitle,
    getProductLineUrl,
} from "@store/Framework/Common/Utilities/productLineUtilities";
import { ProductLineComponentModel } from "@store/Library/Components/ProductLine/ProductLine";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductLineProductTitleProps {
    productInfo?: ProductInfo;
    productLine: ProductLineComponentModel;
}

export interface ProductLineProductTitleStyles {
    title?: TypographyPresentationProps;
    link?: ClickablePresentationProps;
}

export const productLineProductTitleStyles: ProductLineProductTitleStyles = {
    title: {
        css: css`
            ${spacingStyles(null, pxToRem(4))}
            display: inline-flex;
            color: ${getColor("text")};
            font-weight: ${x => x.theme.design.typography.weight.bold};

            ${breakpoint("sm")} {
                font-size: ${x => x.theme.design.typography.size.large};
            }
        `,
    },
    link: {
        css: css`
            ${focusStyles()}
            display: inline-flex;
            transition: ${transitionHoverStyles("color")};

            &:hover {
                color: ${getColor("primary")};
                text-decoration: underline;
            }
        `,
    },
};

const styles = productLineProductTitleStyles;

const ProductLineProductTitle: FC<ProductLineProductTitleProps> = ({ productInfo, productLine }) => {
    const trackSelectItem = ga.use.trackSelectItem({ items: productLine as ProductModel });

    if (!productLine) {
        return null;
    }

    const title = getProductLineTitle(productLine);

    if (!title) {
        return null;
    }

    const url = getProductLineUrl(productLine, productInfo);
    const isActive = getProductLineIsActive(productLine);

    return (
        <Typography {...styles.title}>
            {url && isActive ? (
                <Clickable
                    {...styles.link}
                    href={url}
                    data-test-selector="productDescriptionLink"
                    onClick={() => trackSelectItem()}
                >
                    {title}
                </Clickable>
            ) : (
                title
            )}
        </Typography>
    );
};

export default ProductLineProductTitle;
